"use strict";
/**
 * Catapult REST API Reference
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.7.15
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
* The account properties type: * 0x01 (1 decimal) - The property type only allows receiving transactions from an address. * 0x02 (2 decimal) - The property type only allows receiving transactions containing a mosaic id. * 0x04 (4 decimal) - The property type only allows sending transactions with a given transaction type. * 0x05 (5 decimal) - Property type sentinel. * 0x81 (129 decimal) - The property type blocks receiving transactions from an address. * 0x82 (130 decimal) - The property type blocks receiving transactions containing a mosaic id. * 0x84 (132 decimal) -  The property type blocks sending transactions with a given transaction type.
*/
var AccountPropertyTypeEnum;
(function (AccountPropertyTypeEnum) {
    AccountPropertyTypeEnum[AccountPropertyTypeEnum["NUMBER_1"] = 1] = "NUMBER_1";
    AccountPropertyTypeEnum[AccountPropertyTypeEnum["NUMBER_2"] = 2] = "NUMBER_2";
    AccountPropertyTypeEnum[AccountPropertyTypeEnum["NUMBER_4"] = 4] = "NUMBER_4";
    AccountPropertyTypeEnum[AccountPropertyTypeEnum["NUMBER_5"] = 5] = "NUMBER_5";
    AccountPropertyTypeEnum[AccountPropertyTypeEnum["NUMBER_129"] = 129] = "NUMBER_129";
    AccountPropertyTypeEnum[AccountPropertyTypeEnum["NUMBER_130"] = 130] = "NUMBER_130";
    AccountPropertyTypeEnum[AccountPropertyTypeEnum["NUMBER_132"] = 132] = "NUMBER_132";
})(AccountPropertyTypeEnum = exports.AccountPropertyTypeEnum || (exports.AccountPropertyTypeEnum = {}));
//# sourceMappingURL=accountPropertyTypeEnum.js.map